const styles = `:host {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  height: 2.25rem;
  width: 2.25rem;
  border-radius: var(--goto-radius-small);
  --goto-icon-size: 1.5rem;
  --goto-icon-color: var(--goto-icon-color-secondary);
  background-color: var(--goto-surface-color-secondary);
  display: grid;
  place-items: center;
}

:host([size=xlarge]) {
  height: 3rem;
  width: 3rem;
  --goto-icon-size: 2rem;
  border-radius: var(--goto-radius-medium);
}

:host([size=large]) {
  height: 3rem;
  width: 3rem;
  --goto-icon-size: 2rem;
  border-radius: var(--goto-radius-medium);
}

:host([size=small]) {
  height: 1.5rem;
  width: 1.5rem;
  --goto-icon-size: 1rem;
}

:host([type=pdf]) {
  --goto-icon-color: var(--goto-badge-color-customer);
  background-color: var(--goto-surface-color-danger-secondary);
}

:host([type=document]) {
  --goto-icon-color: var(--goto-badge-color-message);
  background-color: var(--goto-surface-color-brand-secondary);
}

:host([type=spreadsheet]) {
  --goto-icon-color: var(--goto-badge-color-voice);
  background-color: var(--goto-surface-color-success-secondary);
}

:host([type=partner]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-custom);
}

:host([type=audio]) {
  --goto-icon-color: var(--goto-badge-color-audio);
  background-color: var(--goto-surface-color-warning-secondary);
}

:host([type=video]) {
  --goto-icon-color: var(--goto-badge-color-gotoresolve);
  background-color: var(--goto-surface-color-utility-purple);
}

:host([type=call]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-voice);
}

:host([type=messaging]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-message);
}

:host([type=highlighter]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-customer);
}

:host([type=meeting]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-meeting);
}

:host([type=training]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-training);
}

:host([type=assist]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-assist);
}

:host([type=assistmobile]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-assist);
}

:host([type=custom]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-custom);
}

:host([type=webinar]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-webinar);
}

:host([type=gotoresolve]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-gotoresolve);
}

:host([type=gotoresolveremotesupport]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-gotoresolve);
}

:host([type=gotoresolvehelpdesk]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-gotoresolve);
}

:host([type=gotoresolvemobile]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-gotoresolve);
}

:host([type=gotoresolvecamerashare]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-gotoresolve);
}

:host([type=room]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  background-color: var(--goto-badge-color-webinar);
}

:host([type=presentation]),
:host([type=sketch]) {
  --goto-icon-color: var(--goto-badge-color-meeting);
  background-color: var(--goto-surface-color-utility-orange);
}

:host([disabled]) {
  background-color: var(--goto-badge-color-disabled);
  color: var(--goto-type-color-disabled);
  cursor: default;
  --goto-icon-color: var(--goto-icon-color-disabled);
}`; export default styles;